(function () {
    'use strict';

    angular.module('app').factory('translationsService', TranslationsServiceFactory);

    TranslationsServiceFactory.$inject = ['settingsService', 'webApiServices', '$rootScope', 'localStorageService'];
    function TranslationsServiceFactory(settingsService, webApiServices, $rootScope, localStorageService) {

        const store = {
            loading: false,
            callbacks: []
        };

        const translationsDateKey = `${settingsService.appCodeName}_translations_loaded_on`;
        const translationsLanguageKey = `${settingsService.appCodeName}_translations_language`;
        const translationsKey = `${settingsService.appCodeName}_translations`;

        return {
            loadTranslations: loadTranslations,
            GetTranslationByKey: getTranslationByKey,
            CurrentLanguage: settingsService.locale,
        };

        //#region "Implementation of service interface"

        function loadTranslations(callback) {
            // Register the callback
            if (angular.isFunction(callback))
                store.callbacks.push(callback);

            // If the service is in a loading state, wait for the callback
            if (store.loading)
                return;

            const translations = localStorageService.getByKey(translationsKey);
            if (!isLocalStorageOutdated() && translations) {
                onParsed($rootScope.translations || parseTranslations(translations));
            } else {
                store.loading = true;
                webApiServices.GetTranslationsByLanguage(
                    { CultureCode: settingsService.locale.substring(0, 2) },
                    (result) => {
                        localStorageService.setByKey(translationsDateKey, (new Date()).toDateString());
                        localStorageService.setByKey(translationsKey, result.data);
                        localStorageService.setByKey(translationsLanguageKey, settingsService.locale.substring(0, 2));
                        store.loading = false;

                        onParsed(parseTranslations(result.data));
                    },
                    err => console.error("Error loading translations", err),
                    () => store.loading = false
                );
            }
        }

        function getTranslationByKey(key) {
            if (!key || !$rootScope.translations)
                return;

            const translation = $rootScope.translations[key];
            return translation || key;
        }

        //#endregion

        //#region "Internals"

        function isLocalStorageOutdated() {
            const translationsLoadedOn = localStorageService.getByKey(translationsDateKey);
            const translationsLanguage = localStorageService.getByKey(translationsLanguageKey);

            if (!translationsLoadedOn || !translationsLanguage || translationsLanguage !== settingsService.locale.substring(0, 2))
                return true;

            const translationsLoadedOnDate = new Date(translationsLoadedOn);
            //check whether saved date is before today
            return new Date((new Date()).toDateString()) > translationsLoadedOnDate;
        }

        function parseTranslations(json) {
            if (!json)
                return null;
            const translations = {};
            json.forEach((t) => translations[t.Key] = json.find(tr => tr.Key === t.Key).Value);

            $rootScope.translations = translations;

            return translations;
        }

        function onParsed(data) {
            for (const cb of store.callbacks) {
                cb(data);
            }

            store.callbacks = [];
        }

        //#endregion
    }
})();